import { Skeleton } from '@picsart/design-system/components/Skeleton';

import useStyles from './styles';

const ToolsFallback = () => {
  const styles = useStyles();
  return <Skeleton className={styles.skeletonRoot} />;
};

export default ToolsFallback;
